export const SEARCH_MODE = {
  ADDRESS: 'address',
  ADDRESS_ADDRESS: 'address-address',
  ADDRESS_NODE: 'address-node',
  NODE_NODE: 'node-node'
}
